export default "__VITE_ASSET__BLnifipW__"